import icon from 'vue-svgicon';

icon.register({
    'regular/angle-brackets': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M7.629 4.5l-6.44 6.439a1.5 1.5 0 0 0 0 2.121l6.44 6.44M16.371 4.5l6.44 6.439a1.5 1.5 0 0 1 0 2.121l-6.44 6.44" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
